import React, { useEffect } from "react";

import { motion } from "framer-motion";

export const SyaratKetentuan = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="w-full min-h-screen py-20 text-center text-lime-600 flex-col justify-center relative bg-white">
      <div className="container mx-auto px-4">
        <motion.h2
          className="text-2xl font-black uppercase tracking-wider text-lime-600"
          initial={{ opacity: 0, y: -15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
        >
          PT CAKRAWALA JAKARTA KREATIF
        </motion.h2>
        <motion.h3
          className="text-3xl md:text-5xl font-black text-lime-600 mb-8 mt-2"
          initial={{ opacity: 0, y: -15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
        >
          TERMS & CONDITIONS
        </motion.h3>

        <div className="max-w-6xl mx-auto space-y-4">
          <motion.div
            className="text-left"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <div className="bg-white rounded-xl px-4 py-6 border border-slate-200">
              <div className="text-md text-slate-600 space-y-6">
                <h3 className="text-xl font-semibold text-slate-600">
                  Welcome to Cakrawala Jakarta Kreatif!
                </h3>

              <p>
  The following terms and conditions govern the use of the PT
  Cakrawala Jakarta Kreatif Website at{" "}
  <a
    href="https://cakrawalajakarta.com"
    target="_blank"
    rel="noopener noreferrer"
    className="text-lime-600 underline"
  >
    cakrawalajakarta.id
  </a>{" "}
  ,{" "}
  <a
    href="https://jakartaopentrailrun.com"
    target="_blank"
    rel="noopener noreferrer"
    className="text-lime-600 underline"
  >
    jakartaopentrailrun.com
  </a>{" "}
  and all its sub-domains.
</p>


                <p>
                  By accessing this website, you are deemed to have agreed to
                  these terms and conditions. Please do not continue using the
                  Cakrawala Jakarta website if you do not agree to any or all of
                  the terms and conditions listed on this page.
                </p>

                <h3 className="text-xl font-semibold text-slate-600">Cookie</h3>
                <p>
                  This website uses cookies to improve user experience. By
                  accessing our website, you agree to the use of necessary
                  cookies.
                </p>
                <p>
                  Cookies are small text files stored on your device by the
                  website server. These cookies cannot be used to run programs
                  or deliver viruses. Our cookies are used for functionality,
                  analytics, and marketing purposes.
                </p>
                <p>
                  Some cookies are mandatory for the operation of the website.
                  By agreeing to mandatory cookies, you also agree to
                  third-party cookies that may be used through integrated
                  services on this website, such as video displays, forms, or
                  payment services.
                </p>

                <h3 className="text-xl font-semibold text-slate-600">
                  Intellectual Property Rights
                </h3>
                <p>
                  Unless otherwise stated, all intellectual property rights to
                  the content on this website are owned by PT Cakrawala Jakarta
                  Kreatif and/or its licensors. All rights reserved.
                </p>
                <p>
                  You are allowed to access content on this website for personal
                  use, subject to the following conditions:
                </p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>
                    Do not copy or republish material from this website.
                  </li>
                  <li>
                    Do not sell, rent, or sub-license material from this
                    website.
                  </li>
                  <li>
                    Do not duplicate, copy, or reproduce material from this
                    website.
                  </li>
                  <li>
                    Do not redistribute content from this website.
                  </li>
                </ul>

                <h3 className="text-xl font-semibold text-slate-600">
                  User Comments
                </h3>
                <p>
                  Some parts of the website allow users to post comments or
                  information. PT Cakrawala Jakarta Kreatif is not responsible
                  for the content of comments posted by users.
                </p>
                <p>
                  By posting a comment on this website, you declare that:
                </p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>You have the right to post the comment.</li>
                  <li>
                    The comment does not violate the intellectual property
                    rights of any third party.
                  </li>
                  <li>
                    The comment does not contain material that is illegal,
                    defamatory, offensive, or violates privacy.
                  </li>
                  <li>
                    The comment is not used for business promotion or illegal
                    activities.
                  </li>
                </ul>
                <p>
                  You grant a non-exclusive license to PT Cakrawala Jakarta
                  Kreatif to use, reproduce, and edit your comments in any form,
                  format, or media.
                </p>

                <h3 className="text-xl font-semibold text-slate-600">
                  Links to Our Website
                </h3>
                <p>
                  The following organizations are allowed to link to our website
                  without written permission:
                </p>
                <ul className="list-disc list-inside ml-4 space-y-2">
                  <li>Government agencies</li>
                  <li>Search engines</li>
                  <li>News organizations</li>
                  <li>Online directory distributors listed</li>
                  <li>Accredited businesses</li>
                </ul>
                <p>
                  Links must be in context, not misleading, and not imply
                  sponsorship or endorsement by us. We may also consider link
                  requests from other relevant organizations.
                </p>
                <p>
                  If you would like to link to our website, please send a
                  request to PT Cakrawala Jakarta Kreatif along with your
                  organization information and the purpose of the link. We will
                  review the request within 2-3 weeks.
                </p>
                <p>
                  Use of the PT Cakrawala Jakarta Kreatif logo or other visual
                  elements is not permitted without official permission.
                </p>

                <h3 className="text-xl font-semibold text-slate-600">
                  Content Liability
                </h3>
                <p>
                  We are not responsible for content that appears on third-party
                  websites that link to our website. You agree to protect us
                  from any claims arising from content on your website.
                </p>

                <h3 className="text-xl font-semibold text-slate-600">
                  Link Removal
                </h3>
                <p>
                  We reserve the right to request the removal of links to our
                  website at any time. You agree to immediately remove such
                  links upon request.
                </p>

                <h3 className="text-xl font-semibold text-slate-600">
                  Information Accuracy
                </h3>
                <p>
                  We do not guarantee the accuracy, completeness, or
                  availability of the information on this website. The
                  information available is subject to change without notice.
                </p>

                <h3 className="text-xl font-semibold text-slate-600">
                  Disclaimer
                </h3>
                <p>
                  As long as this website is provided for free, we are not
                  responsible for any loss or damage arising from the use of
                  this website, to the extent permitted by applicable law.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
